import { AccountDto, RetrieveAccountsOutputDto } from '@api/izibizi-xp';
import { AvailableAccount } from '@components';
import { useSelectedAccount } from '@store';
import React from 'react';

export const useAvailableAccountListHelper = () => {
	const { selectedAccount } = useSelectedAccount();
	const selectedAccountId = selectedAccount?.account.id;

	const getAvailableAccountsFromDto = (account: AccountDto): AvailableAccount => {
		return {
			name: account.name,
			number: account.accountNumber,
			iban: account.iban,
		} as AvailableAccount;
	};

	const getAvailableAccountsListFromDto = React.useCallback(
		(accountsDto: RetrieveAccountsOutputDto | undefined) => {
			return (
				accountsDto?.entityOut?.clientAccountStructureList?.reduce((availableAccountsList, companyAccount) => {
					if (!companyAccount.accountList?.accountList) {
						return availableAccountsList;
					}

					const selectedAccountExistsInList = companyAccount.accountList?.accountList.find(
						(x) => x.id === selectedAccountId
					);

					for (const account of companyAccount.accountList?.accountList) {
						// add accounts for same company
						if (selectedAccountExistsInList) {
							availableAccountsList.push(getAvailableAccountsFromDto(account));
						}
					}

					return availableAccountsList;
				}, [] as AvailableAccount[]) || []
			);
		},
		[selectedAccountId]
	);

	return { getAvailableAccountsList: getAvailableAccountsListFromDto };
};
